'use strict';

export default class MapLocal {
    constructor() {
        var $map;
        var $default_zoom = 12;
        var $current_location_marker;
        var $default_center = { lat: -37.8362115, lng: 144.966653 };
        var $endpoint = "/api/global/map";
        var $icon_bff_venue = "/themes/aba/images/breastfeeding_friendly_venue.png";
        var $icon_bf_room = "/themes/aba/images/map.icon.bcr.png";
        var $icon_bp = "/themes/aba/images/breastpump.png";
        var $icon_bp = "/themes/aba/images/breastpump.png";
        var $icon_event = "/themes/aba/images/events_becs.png";
        var $icon_lg = "/themes/aba/images/local_group.png";
        var $icon_map = [];
        var $aba_markers = [];
        var $aba_markers_data = [];
        var $aba_infowindows = [];
        var $type_of_markers = {};

        // Load the pins on the map

        // Load the current location of the user



        // Load google map on the canvas
        function initMap() {
            $map = new google.maps.Map(document.getElementsByClassName("map-algolia-map")[0], {
                center: $default_center,
                zoom: $default_zoom,
            });

            $map.addListener("dragend", () => {
                // console.log('Finished moving');
                $('.map-find-me').removeClass('show');
                buildTableOfData();
            });
            $map.addListener("zoom_changed", () => {
                // console.log('Finished zoomed');
                // $('.map-find-me').removeClass('show');
                buildTableOfData()
            });
        }

        // Icon mapping
        function mapIconToContentType() {
            $icon_map["local_group"] = { icon: $icon_lg, zindex: 500, order: 1, visible: true };
            $icon_map["breastfeeding_education_class"] = { icon: $icon_event, zindex: 400, order: 2, visible: true };
            $icon_map["breast_pump"] = { icon: $icon_bp, zindex: 300, order: 3, visible: true };
            $icon_map["breastfeeding_welcome_here_venues"] = { icon: $icon_bff_venue, zindex: 200, order: 4, visible: false };
            $icon_map["baby_care_room"] = { icon: $icon_bf_room, zindex: 100, order: 5, visible: false };
        }

        // Search box allow typing
        function activateSearchBox() {
            // Create the search box and link it to the UI element.
            var $input = document.getElementsByClassName("map-algolia-places")[0];

            clearCurrentLocationMarker();

            var $options = {
                types: ['(regions)'],
                componentRestrictions: { country: 'AU' }
            };
            var $search_box = new google.maps.places.Autocomplete($input, $options);
            var $infowindow = new google.maps.InfoWindow();

            $search_box.bindTo("bounds", $map);

            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            $search_box.addListener("place_changed", () => {
                $('.map-find-me').removeClass('show');

                $current_location_marker = new google.maps.Marker({
                    map: $map
                });

                $infowindow.close();
                $current_location_marker.setVisible(false);

                const place = $search_box.getPlace();

                if (!place.geometry || !place.geometry.location) {
                    // User entered the name of a Place that was not suggested and
                    // pressed the Enter key, or the Place Details request failed.
                    // window.alert("No details available for input: '" + place.name + "'");
                    showMapError();
                    return;
                }

                // If the place has a geometry, then present it on a map.
                if (place.geometry.viewport) {
                    $map.fitBounds(place.geometry.viewport);
                } else {
                    $map.setCenter(place.geometry.location);
                    $map.setZoom(10);
                }

                $current_location_marker.setPosition(place.geometry.location);
                $current_location_marker.setVisible(true);

                // infowindowContent.children["place-name"].textContent = place.name;
                // infowindowContent.children["place-address"].textContent =
                // place.formatted_address;
                // infowindow.open(map, marker);
                // $infowindow.setContent("<p>" + place.formatted_address + "</p>");
                // $infowindow.open($map, $current_location_marker);

                setTimeout(function () {
                    adjustZoomLevelToFindLG();
                }, 1000)
            });
        }

        // Enable the Find me button
        function activateFindMeButton() {

            function getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(showPosition);
                } else {
                    alert("Geolocation is not supported by this browser.");
                }
            }

            function showPosition(position) {
                // $map.panTo({ lat: position.coords.latitude, lng: position.coords.longitude });
                // $map.setZoom(10);
                localStorage.setItem('current_location', JSON.stringify({ 'lat': position.coords.latitude, 'lng': position.coords.longitude }));
                centerMapToStoredLocation();
            }

            $('body').on('click', '.map-algolia-findme', function ($event) {
                $event.preventDefault();
                $('.map-find-me').removeClass('show');
                getLocation();
            })
        }

        // Enable the reset button
        function activateResetButton() {
            $('.map-algolia-reset').click(function () {
                $('.map-algolia-places').val('');
                if (localStorage.getItem('current_location')) {
                    centerMapToStoredLocation();
                } else {
                    $map.panTo($default_center);
                    $map.setZoom($default_zoom);
                }
            });

        }

        // Add the DIV and message 
        function addMessagesBlocks() {
            $('.map-algolia-map').prepend('<div class="map-find-me map-message"><p>Please help us to find your location accurately by clicking on <a class="map-algolia-findme" href="#">Find me</a></p></div>');
            $('.map-algolia-map').prepend('<div class="map-locating map-message"><p>Loading <img class="map-loader-svg" src="/themes/aba/images/spinner.svg"></p></div>');
            $('.map-algolia-map').prepend('<div class="map-loading-data map-message"><p>Loading data <img class="map-loader-svg" src="/themes/aba/images/spinner.svg"></p></div>');
            $('.map-algolia-map').prepend('<div class="map-loading-error map-message"><p>Sorry, cannot load on map</p></div>');
        }

        // Show error message
        function showMapError() {
            $('.map-loading-error').addClass('show');
            setTimeout(function () {
                $('.map-loading-error').removeClass('show')
            }, 2000)
        }

        // Center map to stored cordinate
        function centerMapToStoredLocation() {
            $('.map-find-me').removeClass('show');
            $('.map-locating').addClass('show');
            var $cordinate = JSON.parse(localStorage.getItem('current_location'));
            clearCurrentLocationMarker();
            setTimeout(function () {
                $map.panTo({ lat: $cordinate.lat, lng: $cordinate.lng });
                $map.setZoom($default_zoom + 1);
                $('.map-locating').removeClass('show');

                $current_location_marker = new google.maps.Marker({
                    map: $map,
                    position: { lat: $cordinate.lat, lng: $cordinate.lng }
                });

                adjustZoomLevelToFindLG();

            }, 1200)
        }

        // Check if there is a stored location
        function getCurrentLocation() {
            if (localStorage.getItem('current_location')) {
                centerMapToStoredLocation();
            } else {
                $('.map-find-me').addClass('show');
            }
        }

        // Reset the current location marker
        function clearCurrentLocationMarker() {
            try {
                $current_location_marker.setMap(null);
            } catch (error) {
                // console.log(error);
                // Marker error
            }
        }

        // Load the data from views rest api on map
        function loadDataOnMap() {
            $.ajax({
                dataType: "json",
                url: $endpoint,
                beforeSend: function () {
                    $('.map-loading-data').addClass('show');
                }
            })
                .done(function ($raw_data) {
                    // console.log($raw_data);
                    addMarkersOnMap($raw_data);
                    addTypeFacets();
                    $('.map-loading-data').removeClass('show');

                })
                .fail(function () {
                    // Something to show the map has failed
                })
                .always(function () {
                    // Remove preloader?
                });
        }

        // Add all the pins on the map
        function addMarkersOnMap($raw_data) {
            $.each($raw_data, function ($index, $item) {
                // console.log($item);
                if (getLatLngFromString($item.field_location)) {

                    // Construct the type of markers array
                    $type_of_markers[$item.type_code] = $item.type;

                    // Add the marker on the map and add the data to the data array
                    $aba_markers_data[$item.nid] = $item;
                    $aba_markers[$item.nid] = new google.maps.Marker({
                        map: $map,
                        position: getLatLngFromString($item.field_location),
                        icon: $icon_map[$item.type_code].icon,
                        visible: false,
                        zIndex: $icon_map[$item.type_code].zindex
                    });

                    // Set the initial state of the icon
                    setTimeout(function () {
                        $aba_markers[$item.nid].setVisible($icon_map[$item.type_code].visible);
                    }, 5)

                    // Add the popup window to the map
                    $aba_infowindows[$item.nid] = new google.maps.InfoWindow({
                        content: buildHTMLPopup($item),
                    });

                    // Bind the marker to the popup
                    $aba_markers[$item.nid].addListener("click", () => {
                        $map.panTo($aba_markers[$item.nid].getPosition());
                        $aba_infowindows[$item.nid].open({
                            anchor: $aba_markers[$item.nid],
                            shouldFocus: true,
                        });
                    });
                }


            })

            $map.setZoom($default_zoom);
        }

        // Build HTML popup
        function buildHTMLPopup($data) {
            var $html = '', $title = '', $address = '', $links = '', $datetime = '', $pump_count = '';
            // Title
            $title = '<h5><a href="' + $data.view_node + '">' + $data.title + '</a></h5>';

            // Links
            $links = "<div class='links'>";
            if ($data.type_code == 'local_group') {
                $($data.field_calendar).length > 0 !== "" ? $links += '<a class="local-group-link" href="' + $data.view_node + '#calendar">Calendar</a>' : '';
                $data.field_breastpump_hire !== "0" ? $links += '<a class="local-group-link" href="' + $data.view_node + '#breastpump">Breastpump</a>' : '';
                $($data.field_classes).length > 0 ? $links += '<a class="local-group-link" href="' + $data.view_node + '#classes">Classes</a>' : '';
            }

            if ($data.type_code == 'breast_pump') {
                $links += '<a class="button pink" href="' + $data.view_node + '">Contact group</a>';
            }
            $links += "</div>";

            if ($data.field_smartdate && $data.type_code == "breastfeeding_education_class") {
                // Date time
                var $date = new Date($data.field_smartdate * 1000);
                $datetime = "<div class='datetime'>";
                $datetime += "  <div class='date'>" + $date.toDateString() + "</div>";
                $datetime += "  <div class='time'>" + $date.getHours() + ":" + ($date.getMinutes() < 10 ? '0' : '') + $date.getMinutes() + "</div>";
                $datetime += "  <div class='time'><small>" + $data.field_timezone + "</small></div>";
                $datetime += "</div>";
            } else {
                // Address
                $address = '<div class="address">';
                $address += '   <span>' + $data.field_address_address_line1 + '</span>';
                $address += '   <span>' + $data.field_address_address_line2 + '</span>';
                $address += '   <span>' + $data.field_address_locality + '</span>';
                $address += '   <span>' + $data.field_address_postal_code + '</span>';
                $address += '   <span>' + $data.field_address_administrative_area + '</span>';
                $address += '</div>';
            }

            if ($data.type_code == 'breast_pump') {
                $pump_count = '<div class="pump_count">Pumps available: ' + parseInt($data.field_pumps_available) + '</div>';
            }

            $html = '<div class="popup-information ' + $data.type_code + '">' + $title + $datetime + $address + $pump_count + $links + '</div>';


            return $html;
        }

        // Convert text string to Lat and Lng
        function getLatLngFromString($string) {
            if ($string) {
                var $array = $string.split(",");
                return ({
                    lat: parseFloat($array[0].trim()),
                    lng: parseFloat($array[1].trim())
                })
            } else {
                return false;
            }
        }

        // Find the closest Local group
        function adjustZoomLevelToFindLG() {
            $('.map-locating').addClass('show');
            var $map_zoom_level = $map.getZoom();
            var $found_match = false;
            var $ready_to_stop_zoom = false;

            if (!areThereEnoughToZoom()) {
                buildTableOfData();
                $('.map-locating').removeClass('show');
                return false;
            } else {
                setTimeout(function () {
                    while ($map_zoom_level > 0 && $ready_to_stop_zoom == false) {
                        var $pin_count = 0;
                        $aba_markers.forEach(function ($marker, $key) {
                            if ($marker.visible && $map.getBounds().contains($marker.getPosition())) {
                                $pin_count++;
                                if ($aba_markers_data[$key].type_code == 'local_group') {
                                    $found_match = true;
                                } else {
                                    // Marker is not a local group
                                }
                            } else {
                                // Marker is not in bound
                            }

                            if (($pin_count > 4) && $found_match) {
                                $ready_to_stop_zoom = true;
                            }
                        });

                        // console.log($pin_count)

                        if (!$ready_to_stop_zoom) {
                            $map_zoom_level = $map_zoom_level - 1;
                            $map.setZoom($map_zoom_level);
                        }
                    }

                    $('.map-locating').removeClass('show');

                    buildTableOfData();
                }, 400)
            }



        }

        // Check if there are enough valid pins to zoom
        function areThereEnoughToZoom() {
            var $pin_count = 0;
            var $found_match = false;
            var $ready_to_stop_zoom = false;
            $aba_markers.forEach(function ($marker, $key) {
                if ($marker.visible) {
                    $pin_count++;
                    if ($aba_markers_data[$key].type_code == 'local_group') {
                        $found_match = true;
                    } else {
                        // Marker is not a local group
                    }
                } else {
                    // Marker is not in bound
                }

                if (($pin_count > 4) && $found_match) {
                    $ready_to_stop_zoom = true;
                }
            });

            return $ready_to_stop_zoom;
        }

        // Add the type of markers facets
        function addTypeFacets() {
            var $filter_wrapper = '<div class="ais-RefinementList"><ul class="ais-RefinementList-list">{{placeholder}}</ul></div>';
            var $filter_facet_template = '<li class="ais-RefinementList-item"><div><label class="ais-RefinementList-label"> <input class="ais-RefinementList-checkbox map-facet-checkbox" type="checkbox" value="{{name_value}}" data-code="{{code}}" checked /> <span class="ais-RefinementList-labelText">{{name}}</span> <span class="ais-RefinementList-count">{{count}}</span> </label></div></li>';
            var $filter_facet_template_unchecked = '<li class="ais-RefinementList-item"><div><label class="ais-RefinementList-label"> <input class="ais-RefinementList-checkbox map-facet-checkbox" type="checkbox" value="{{name_value}}" data-code="{{code}}" /> <span class="ais-RefinementList-labelText">{{name}}</span> <span class="ais-RefinementList-count">{{count}}</span> </label></div></li>';
            var $filter_facet_template_locked = '<li class="ais-RefinementList-item" locked><div><label class="ais-RefinementList-label locked"> <input disabled class="ais-RefinementList-checkbox map-facet-checkbox" type="checkbox" value="{{name_value}}" data-code="{{code}}" checked /> <span class="ais-RefinementList-labelText">{{name}}</span> <span class="ais-RefinementList-count">{{count}}</span> </label></div></li>';
            var $filter_facets = '';
            var $sorted_facet = [];

            // Order the facets
            $.each($type_of_markers, function ($index, $item) {
                $sorted_facet[$icon_map[$index].order] = { code: $index, label: $item }
            })

            $sorted_facet.forEach(function ($item, $index) {
                if ($icon_map[$item.code].visible) {
                    $filter_facets += $filter_facet_template.replace('{{name}}', $item.label).replace('{{name_value}}', $item.label).replace('{{code}}', $item.code);
                } else {
                    $filter_facets += $filter_facet_template_unchecked.replace('{{name}}', $item.label).replace('{{name_value}}', $item.label).replace('{{code}}', $item.code);
                }
            });

            // $.each($type_of_markers, function ($index, $item) {
            //     console.log($item);
            //     // if ($index == "local_group") {
            //     //     // $filter_facets += $filter_facet_template_locked.replace('{{name}}', $item).replace('{{name_value}}', $item).replace('{{code}}', $index);
            //     //     $filter_facets += $filter_facet_template.replace('{{name}}', $item).replace('{{name_value}}', $item).replace('{{code}}', $index);
            //     // } else {

            //     // }
            //     if ($icon_map[$index].visible) {
            //         $filter_facets += $filter_facet_template.replace('{{name}}', $item).replace('{{name_value}}', $item).replace('{{code}}', $index);
            //     } else {
            //         $filter_facets += $filter_facet_template_unchecked.replace('{{name}}', $item).replace('{{name_value}}', $item).replace('{{code}}', $index);
            //     }
            // });

            $('.map-algolia-filters').html($filter_wrapper.replace('{{placeholder}}', $filter_facets));
        }

        function bindFacetAction() {
            $('body').on('change', '.map-facet-checkbox', function () {
                var $type_code = $(this).data('code');
                var $checkbox_state = $(this).prop("checked");

                console.log($type_code);
                console.log($checkbox_state);

                $aba_markers_data.forEach(function ($marker, $key) {
                    if ($marker.type_code == $type_code) {
                        $aba_markers[$key].setVisible($checkbox_state);
                    }
                })

                adjustZoomLevelToFindLG();
            });
        }

        function buildTableOfData() {
            var $table_container_template = '<div class="ais-Hits"><ol class="ais-Hits-list">{{placeholder}}</ol></div>';
            var $table_row_template = '<li class="ais-Hits-item"><div class="item nid-{{nid}}"><ul><li class="icon {{code}}"></li><li class="name"><a class="table-map-link" href="{{url}}" data-nid="{{nid}}">{{title}}</a></li><li class="address">{{address}}</li><li class="contact">{{contact}}</li></ul></div></li>';
            var $table_row = '';

            $('.map-locating').addClass('show');
            setTimeout(function () {
                $aba_markers.forEach(function ($marker, $key) {
                    if ($marker.visible && $map.getBounds().contains($marker.getPosition())) {
                        var $nid = $key;
                        var $code = $aba_markers_data[$key].type_code;
                        var $title = $aba_markers_data[$key].title;
                        var $url = $aba_markers_data[$key].view_node;
                        var $address = $aba_markers_data[$key].field_address;
                        var $contact = $aba_markers_data[$key].field_contact_details;

                        $table_row += $table_row_template
                            .replace('{{nid}}', $nid)
                            .replace('{{code}}', $code)
                            .replace('{{title}}', $title)
                            .replace('{{url}}', $url)
                            .replace('{{address}}', $address)
                            .replace('{{contact}}', $contact)

                    }
                });

                var $table_container = $table_container_template.replace('{{placeholder}}', $table_row)
                $('.map-algolia-result').html($table_container);
                $('.map-locating').removeClass('show');

            }, 400)

        }

        function activateFilterFromQuery() {

            $.urlParam = function (name) {
                var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                    .exec(window.location.search);

                return (results !== null) ? results[1] || 0 : false;
            }


            if ($.urlParam('show_only')) {

                console.log('Filtering on:', $.urlParam('show_only'));

                $('.map-facet-checkbox').each(function () {
                    if ($(this).is(':checked')) {
                        $(this).closest('label').click()
                    }
                });


                setTimeout(function () {
                    var $code = $.urlParam('show_only');
                    $('.map-facet-checkbox').each(function () {
                        if ($(this).data('code') == $code) {
                            $(this).closest('label').click()
                        }
                    });
                }, 1800);

            }




        }

        if ($('.map-algolia-map').length) {
            setTimeout(function () {
                initMap();
                mapIconToContentType();
                activateSearchBox();
                activateFindMeButton();
                activateResetButton();
                addMessagesBlocks();
                getCurrentLocation();
                loadDataOnMap();
                bindFacetAction();
            }, 500)

            setTimeout(function () {
                activateFilterFromQuery();
            }, 1500)
        }

    }
}
